import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-rotate-icon',
  templateUrl: './rotate-icon.component.html',
  styleUrls: ['./rotate-icon.component.scss'],
  imports: [CommonModule],
})
export class RotateIconComponent {
  @Input() imageUrl: string;
  @Input() animate: boolean;
}
